class BeforeAfter extends HTMLElement {
  constructor() {
    super();

    this.beforeImage = this.querySelector('.before-image');
    this.afterImage = this.querySelector('.after-image');
    this.splitter = this.querySelector('.before-after-splitter');
    this.handleMarker = this.querySelector('.handle-marker');
    this.isDragging = false;

    if (!this.beforeImage || !this.afterImage || !this.splitter || !this.handleMarker) {
      return;
    }

    this.handleMarker.addEventListener('mousedown', this.onMouseDown.bind(this));
    this.handleMarker.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: false });

    window.addEventListener('mousemove', this.onMouseMove.bind(this));
    window.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false });

    window.addEventListener('mouseup', this.onMouseUp.bind(this));
    window.addEventListener('touchend', this.onTouchEnd.bind(this));

    this.addEventListener('click', this.onClick.bind(this));
  }

  onMouseDown(event) {
    this.isDragging = true;
    if (this.closest('custom-grid')) this.closest('custom-grid').isDragging = false;
    event.preventDefault();
  }

  onMouseMove(event) {
    if (!this.isDragging) return;
    this.updatePosition(event.clientX);
  }

  onMouseUp(event) {
    this.isDragging = false;
  }

  onTouchStart(event) {
    this.isDragging = true;
    if (this.closest('custom-grid')) this.closest('custom-grid').isDragging = false;
    event.preventDefault();
  }

  onTouchMove(event) {
    if (!this.isDragging) return;

    const touch = event.touches[0];
    this.updatePosition(touch.clientX);
  }

  onTouchEnd(event) {
    this.isDragging = false;
  }

  onClick(event) {
    this.updatePosition(event.clientX);
  }

  updatePosition(clientX) {
    const rect = this.getBoundingClientRect();
    const offsetX = clientX - rect.left;
    const percentage = Math.max(0, Math.min((offsetX / rect.width) * 100, 100));

    this.updateClipPath(percentage);
  }

  updateClipPath(percentage) {
    this.beforeImage.style.clipPath = `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0 100%)`;
    this.afterImage.style.clipPath = `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`;
    this.splitter.style.left = `${percentage}%`;
  }
}

customElements.define('before-after-item', BeforeAfter);